export enum UserExpenseScope {
  workingSite, user
}
